export enum FormFieldType {
	TEXT = 'TEXT',
	TEXTAREA = 'TEXTAREA',
	SELECTION = 'SELECTION',
	MULTI_SELECTION = 'MULTI_SELECTION',
	DATE = 'DATE',
	TIME = 'TIME',
	CHECKBOX = 'CHECKBOX',
	NUMBER_STEPPER = 'NUMBER_STEPPER',
	RADIO = 'RADIO',
}

export interface FormFieldOption {
	id: string | number;
	label: string;
	value?: string | number | boolean;
	displayOrder: number;
}

export interface FormFieldConfig {
	id: string | number;
	name?: string;
	tooltip?: string;
	tabIndex?: number;
	type: FormFieldType;
	top?: number;
	left?: number;
	width?: number;
	height?: number;
	multiple?: boolean; // for select-like controls
	options?: FormFieldOption[];
}

export interface FieldClick<TValue = unknown> {
	$event: MouseEvent;
	id: string | number;
	value: TValue;
}
